import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { formatParentData } from '../../helpers/entryFormatters';

const API_URL = `${process.env.REACT_APP_API_URL}/api/v1`;

export const getParentPickupInfo = createAsyncThunk(
  'parentInfo/getParentPickupInfo',
  async (pickupId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/parent/all?pickupId=${pickupId}`);
      const data = formatParentData(response.data.data[0]);
      return data;
    } catch (error) {
      return rejectWithValue('Sorry, We could not find your pickup information');
    }
  }
);

export const updateParentPickup = createAsyncThunk(
  'parentInfo/updateParentPickup',
  async (data, { rejectWithValue }) => {
    const pickupObj = {
      pickup: true,
      confirmCode: data.confirmCode,
    };

    try {
      const response = await axios.put(`${API_URL}/parent/pickup/admin-code/${data.pickupId}`, pickupObj, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data?.message;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'incorrect admin code');
    }
  }
);

const initialParentInfoState = {
  parentEntries: [],
  childrenEntries: [],
  approved: null,
  loading: false,
  error: null,
  success: false,
  pickup: null,
  updateLoading: false,
  updateSuccess: false,
  updateError: null,
  updateMessage: null,
};

const parentInfoSlice = createSlice({
  name: 'parentInfo',
  initialState: initialParentInfoState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getParentPickupInfo.pending, (state) => {
        state.loading = true;
      })
      .addCase(getParentPickupInfo.fulfilled, (state, action) => {
        Object.assign(state, action.payload);
        state.loading = false;
        state.success = true;
      })
      .addCase(getParentPickupInfo.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      })
      .addCase(updateParentPickup.pending, (state) => {
        state.updateLoading = true;
      })
      .addCase(updateParentPickup.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.updateSuccess = true;
        state.pickup = true;
        state.updateMessage = action.payload;
      })
      .addCase(updateParentPickup.rejected, (state, action) => {
        state.updateLoading = false;
        state.updateError = action.payload;
      });
  },
});

export default parentInfoSlice.reducer;
